import * as math from 'mathjs';

const performMonteCarloOptimization1 = ({
    numSimulations,
    gamma,
    selectedAssets,
    covarianceMatrix,
    returnsArray,
    ESGmin,
}) => {
    const numAssets = selectedAssets?.length || 0;

    if (!selectedAssets || selectedAssets.length < 2) {
        console.error("You need to select at least two assets.");
        return [];
    }

    let bestObjectiveValue = -10000;
    let bestWeights = null;

    for (let i = 0; i < numSimulations; i++) {
        let weights = Array.from({ length: numAssets }, () => Math.random());
        const sumWeights = weights.reduce((a, b) => a + b, 0);
        weights = weights.map(weight => weight / sumWeights); // Normalize weights to sum up to 1

        // Calculate the portfolio's return and variance
        const variancePart = math.multiply(math.multiply(weights, covarianceMatrix), math.transpose(weights));
        const returnPart = math.multiply(weights, returnsArray);
        
        // Calculate the ESG score for the portfolio
        const ESGscores = selectedAssets.map(asset => asset.ESGworkforce + asset.ESGstrategy);
        const portfolioESGscore = math.dot(weights, ESGscores);
        
        // Check if the portfolio meets the ESG minimum requirement
        if (portfolioESGscore >= ESGmin) {
            // Check if this is the best (minimum) objective value so far
            const objectiveValue = returnPart;
            if (objectiveValue > bestObjectiveValue) {
                bestObjectiveValue = objectiveValue;
                bestWeights = weights;
            }
        }

    }


    if (bestWeights) {
        const bestReturn = math.dot(bestWeights, returnsArray);
        console.log("Best Return:", bestReturn);
        return bestWeights;
    } else {
        return "No feasible solution meets the ESG requirement.";
    }
};

export default performMonteCarloOptimization1;
